export const colors = {
  // primary
  primary25: '#fafbf9',
  primary50: '#f6f8f4',
  primary100: '#eaefe6',
  primary200: '#c2d0b7',
  primary300: '#a1b690',
  primary400: '#6f8a5a',
  primary500: '#00553d',
  primary600: '#004e38',
  primary700: '#004733',
  primary800: '#003929',
  primary900: '#002319',

  // secondary
  secondary50: '#fef6ec',
  secondary100: '#fddcb4',
  secondary200: '#fccb8e',
  secondary300: '#faba68',
  secondary400: '#f9a843',
  secondary500: '#f8971d',
  secondary600: '#d97706',
  secondary700: '#ac622a',
  secondary800: '#92400e',
  secondary900: '#78350f',

  // error
  error50: '#fef2f2',
  error100: '#fee2e2',
  error200: '#fecaca',
  error300: '#fca5a5',
  error400: '#f87171',
  error500: '#ef4444',
  error600: '#dc2626',
  error700: '#b91c1c',
  error800: '#991b1b',
  error900: '#7f1d1d',

  info50: '#dfefff',
  info100: '#9fd0fe',
  info200: '#5eb1fe',
  info300: '#2b83d3',
  info400: '#0261b8',
  info500: '#013f78',
  info600: '#013260',
  info700: '#012648',
  info800: '#001d38',
  info900: '#001528',

  // grey
  grey50: '#fbfbfc',
  grey100: '#f7f8f8',
  grey200: '#ecedee',
  grey300: '#e1e1e4',
  grey400: '#d5d6da',
  grey500: '#b3b5bc',
  grey600: '#9b9da7',
  grey700: '#6b6f7a',
  grey800: '#404249',
  grey900: '#151618',

  //shades
  shade0: '#ffffff',
  shade100: '#000000',
}
